import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map, Observable } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
    constructor(
        private router: Router,
        private authService: AuthService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.authService.sessionData.pipe(
            map((data) => {

                if (!data.isLoggedIn || data.user.expires <= Date.now()) {
                    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                    this.authService.expired();
                    return false;
                }

                if (data.user.isSystemAdmin || data.user.roles.includes("administration")) {
                    return true;
                }

                console.warn('AdminGuard: Zugriff verweigert - keine Admin-Berechtigung');
                this.router.navigate(['/store']);
                return false;
            })
        );
    }
}
